import React from 'react';
import { FormAsyncMultiSelect } from '@getro/rombo';
import { Formik, Form, Field } from 'formik';
import PropTypes from 'prop-types';
import { useLazyGetMovementsCompaniesQuery } from '../../../../services/movements';
import { FormikAutoSubmit } from '../../../../components/atoms/formikAutoSubmit';

export const MovementCompanyFilter = ({ value, setFilters }) => {
  const [getMovementsCompanies] = useLazyGetMovementsCompaniesQuery();

  const onSearchChange = (currentValue) =>
    getMovementsCompanies({ query: currentValue || '' })
      .unwrap()
      .then((res) => res)
      .catch(() => []);

  const onSubmit = ({ companies }) => {
    setFilters({ companies: companies || [] });
  };

  return (
    <Formik initialValues={{ companies: value || [] }} onSubmit={onSubmit} enableReinitialize>
      <Form>
        <FormikAutoSubmit />
        <Field
          name="companies"
          label="Company"
          placeholder="Search"
          size="small"
          component={FormAsyncMultiSelect}
          loadOptions={onSearchChange}
          anchorToBody
        />
      </Form>
    </Formik>
  );
};

MovementCompanyFilter.propTypes = {
  value: PropTypes.array,
  setFilters: PropTypes.func.isRequired,
};

MovementCompanyFilter.defaultProps = {
  value: [],
};
